import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Toolbar,
  Typography,
  IconButton,
  Button,
  CssBaseline,
  AppBar,
  Menu,
  MenuItem,
  Paper,
  Box,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
  Grid,
  TextField,
  DialogActions,
} from "@mui/material";

import Breakdown from "../dashboard/Breakdown";
import makeStyles from "@mui/styles/makeStyles";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LinearProgress from "@mui/material/LinearProgress";
import { Divider } from "@material-ui/core";

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import StoreIcon from "@mui/icons-material/Store";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";

//Calendar
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { format } from "date-fns";
import addMonths from "date-fns/addMonths";

import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const drawerWidth = 300;
const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBarTop: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  grow: {
    flexGrow: 1,
  },

  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      padding: ".2rem",
    },
  },

  kpi: {
    fontWeight: "bold",
    width: "25%",
  },
  target: {
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  actual: {
    position: "relative",
    width: "20%",
  },
  yellowButton: {
    backgroundColor: "#ffff00",
    color: "black",
    "&:hover": {
      backgroundColor: "#ffff00",
    },
  },
  actual_by_value: {
    fontWeight: "bold",
  },
  targetValuesContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "10px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  horizontalLine: {
    border: 0,
    borderTop: "1px solid #000000",
    width: "100%",
    margin: "5px 0",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
}));

const objectToFormData = (object) =>
  Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);

    return formData;
  }, new FormData());

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

export default function DashboardVersion2(props) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(() => false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);
  const [openSellerMenu, setOpenSellerMenu] = useState(false);

  const reach_and_range_targets = 50;
  const [hover, setHover] = useState(false);

  const [targets, setTargets] = useState(0);
  const [sellers, setSellers] = useState(0);
  const [selectedSeller, setSelectedSeller] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [openBreakdownDialog, setOpenBreakdownDialog] = useState(false);
  const [selectedBreakdown, setSelectedBreakdown] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  //Date filter
  const [openFilterByDateMenu, setOpenFilterByDateMenu] = useState(false);
  const [openStartingDateCalendar, setOpenStartingDateCalendar] =
    useState(false);
  const [openDateFilterDialog, setOpenDateFilterDialog] = useState(false);
  const [startingFilterDate, setStartingFilterDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  ); // Default to the first day of the current month
  const [endingFilterDate, setEndingFilterDate] = useState(new Date());
  const [selectedFilterDateType, setSelectedFilterDateType] = useState("");
  const [endingDate, setEndingDate] = React.useState(new Date());
  const [startingDate, setStartingDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  ); // Default to the first day of the current month
  const [openEndingDateCalendar, setOpenEndingDateCalendar] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const formattedStartingDate = format(startingDate, "yyyy-MM-dd");
      const formattedEndingDate = format(endingDate, "yyyy-MM-dd");
      const FormattedDateRange = {
        formattedStartingDate,
        formattedEndingDate,
        selectedFilterDateType,
      };

      await loadTargets(
        selectedSeller,
        FormattedDateRange,
        selectedFilterDateType
      );
      await loadSellers();
      setButtonDisabled(false);
    }
    fetchData();
  }, [selectedSeller, startingDate, endingDate, selectedFilterDateType]);

  const handleClickMyTargets = async () => {
    setSelectedSeller("");
    loadTargets("", {
      formattedStartingDate: format(startingDate, "yyyy-MM-dd"),
      formattedEndingDate: format(endingDate, "yyyy-MM-dd"),
      selectedFilterDateType: "",
    });
  };

  const loadTargets = async (value, FormattedDateRange) => {
    setIsLoading(true);

    const options = {
      method: "POST",
      url: "/TransactiReachAndRangeTargets/getReachAndRangeTargets.json",
      data: objectToFormData({
        selected_seller: JSON.stringify(value),
        startingDate: FormattedDateRange.formattedStartingDate,
        endingDate: FormattedDateRange.formattedEndingDate,
        dateFormatType: FormattedDateRange.selectedFilterDateType,
      }),
    };
    await axios(options).then((res) => {
      if (res.data.response.is_success === false) {
        console.log("No Reanch and Range Targets Found");
        return;
      }
      const dashboard_targets = res.data.response.dashboard_targets;

      if (
        dashboard_targets.num_doors_target === 0 &&
        dashboard_targets.reach_percentage === 0 &&
        dashboard_targets.range_percentage === 0 &&
        dashboard_targets.num_skus_target_per_door === 0
      ) {
        dashboard_targets.num_doors_target = 50;
        dashboard_targets.reach_percentage = 70;
        dashboard_targets.range_percentage = 85;
        dashboard_targets.num_skus_target_per_door = 7;
      }

      setTargets(dashboard_targets);
      setIsLoading(false);
    });
  };

  const loadSellers = async () => {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/TransactiSalesman/getTransactiSellerUsers.json",
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;
        if (!isSuccess) {
          alert("Error encounter");
          return;
        }
        setSellers(res.data.response.Salesmans);
      })
      .catch((error) => {
        alert("Error encounter");
        console.log(error);
      });
    setIsLoading(false);
  };

  const menuHandleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const SelectSellerDialog = () => {
    return (
      <Dialog open={openSellerMenu} maxWidth="sm" fullWidth>
        <DialogTitle style={{ fontWeight: "bold", textAlign: "center" }}>
          Select Seller
        </DialogTitle>
        <DialogContent dividers>
          <List>
            {sellers.length > 0 &&
              sellers.map((value, index) => (
                <ListItem button divider key={value["username"]}>
                  <ListItemText
                    primary={`${index + 1}. ${value["first_name"]} ${
                      value["middle_name"]
                    } ${value["last_name"]}  (${value["username"]})`}
                    onClick={() => handleSelectSeller(value)}
                  />
                </ListItem>
              ))}
          </List>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "15px",
            }}
          >
            <Button
              variant="contained"
              className={classes.yellowButton}
              onClick={() => {
                setOpenSellerMenu(false);
              }}
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  const BreakdownDialog = () => {
    return (
      <Breakdown
        openBreakdownDialog={openBreakdownDialog}
        setOpenBreakdownDialog={setOpenBreakdownDialog}
        selectedBreakdown={selectedBreakdown}
        targets={targets}
        formattedSelectedDate={{ startingDate, endingDate }}
      />
    );
  };

  const handleSelectSeller = (seller) => {
    setOpenSellerMenu(false);
    setSelectedSeller(seller);
  };

  const checkMobileResponsive = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  useEffect(() => {
    checkMobileResponsive();

    window.addEventListener("resize", checkMobileResponsive);

    return () => {
      window.removeEventListener("resize", checkMobileResponsive);
    };
  }, []);

  const handleFilterByDateClick = () => {
    setOpenDateFilterDialog(true);
    setMenuAnchorEl(null);
  };

  const getLabel = () => {
    const formattedStartingDate = format(startingDate, "yyyy-MM-dd");
    const formattedEndingDate = format(endingDate, "yyyy-MM-dd");
    const startMonth = format(new Date(formattedStartingDate), "MMMM");
    const endMonth = format(new Date(formattedEndingDate), "MMMM");
    const startYear = format(new Date(formattedStartingDate), "yyyy");
    const endYear = format(new Date(formattedEndingDate), "yyyy");

    let filterDateLabel;
    if (startMonth === endMonth && startYear === endYear) {
      filterDateLabel = `Filter Date: ${startMonth} ${startYear}`;
    } else {
      filterDateLabel = `Filter Date: ${startMonth} ${startYear} - ${endMonth} ${endYear}`;
    }

    return {
      filterDateLabel,
    };
  };

  const label = getLabel();

  const computeAchievementKPI = (target, actual, threshold) => {
    let value = 0;
    if (!isNaN(target) && target > 0 && !isNaN(actual) && actual > 0) {
      value = (actual / target) * 100;
    }

    const percentage = value.toFixed(2);
    let color = percentage >= threshold ? "green" : "red";
    return (
      <Typography component="span" display="inline" sx={{ color: color }}>
        {percentage}%
      </Typography>
    );
  };

  const setMonthToDate = () => {
    const start = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const end = new Date();
    setStartingDate(start);
    setEndingDate(end);
    filterTargetsByDate(startingDate, endingDate);
    setSelectedFilterDateType("MonthToDate");
    setOpenDateFilterDialog(false);
  };

  const setYearToDate = () => {
    const start = new Date(new Date().getFullYear(), 0, 1);
    const end = new Date();
    setStartingDate(start);
    setEndingDate(end);
    filterTargetsByDate(startingDate, endingDate);
    setSelectedFilterDateType("YearToDate");
    setOpenDateFilterDialog(false);
  };

  const handleApplyClick = () => {
    setOpenDateFilterDialog(false);
    setSelectedFilterDateType("CustomDateRange");
  };

  const shouldDisableEndDate = (date) => {
    if (!startingDate) return false;
    const maxEndDate = addMonths(startingDate, 12);
    return date > maxEndDate || date < startingDate;
  };

  const shouldDisableStartDate = (date) => {
    if (!endingDate) return false;
    const minStartDate = addMonths(endingDate, -12);
    return date < minStartDate || date > endingDate;
  };

  const SelectDateRangeFilterDialog = () => {
    return (
      <Dialog open={openDateFilterDialog} maxWidth="sm" fullWidth>
        <DialogTitle style={{ fontWeight: "bold", textAlign: "center" }}>
          Filter by Date
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={setMonthToDate}
                fullWidth
              >
                Month to Date
              </Button>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "left" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={setYearToDate}
                fullWidth
              >
                Year to Date
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="Starting Date"
                  inputFormat="MM/dd/yyyy"
                  value={startingDate}
                  onChange={(newValue) => {
                    setStartingDate(newValue);
                  }}
                  shouldDisableDate={shouldDisableStartDate}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="Ending Date"
                  inputFormat="MM/dd/yyyy"
                  value={endingDate}
                  onChange={(newValue) => {
                    setEndingDate(newValue);
                  }}
                  shouldDisableDate={shouldDisableEndDate}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className={classes.yellowButton}
            onClick={() => {
              setOpenDateFilterDialog(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const filterTargetsByDate = (startDate, endDate) => {};

  const main = () => {
    return (
      <>
        <List sx={{ marginTop: ".5em" }}>
          {salesKPI()}
          {reachKPI()}
          {rangeKPI()}
          {appUsageKPI()}
        </List>
      </>
    );
  };

  const salesKPI = () => {
    return (
      <>
        <ListItem
          button
          divider
          onClick={() => {
            setOpenBreakdownDialog(true);
            setSelectedBreakdown("Sales");
          }}
        >
          <ListItemText>
            <Grid container sx={{ position: "relative" }}>
              <TrendingUpIcon
                sx={{
                  fontSize: "15em",
                  color: "#edece6",
                  position: "absolute",
                  top: "50%",
                  right: "1%", // Push it to the right side
                  transform: "translateY(-50%)", // Center vertically
                  zIndex: -2,
                }}
              />
              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="h6">
                    <TrendingUpIcon
                      sx={{ fontSize: "large", color: "green" }}
                    />{" "}
                    <b>{"SALES"}</b>
                  </Typography>
                  <Typography variant="body2">sales vs targets</Typography>
                </Box>
              </Grid>

              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="body1">
                    TARGET: &nbsp;
                    {Number(
                      targets.monthly_target ? targets.monthly_target : 0
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>

                  <Typography variant="body1">
                    ACTUAL:&nbsp;₱
                    {Number(
                      targets.total_sales ? targets.total_sales : 0
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>

                  <Typography variant="body1">
                    BALANCE:&nbsp;₱
                    {Number(
                      targets.monthly_target - targets.total_sales > 0
                        ? targets.monthly_target - targets.total_sales
                        : 0
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                  <Typography component="span" display="inline" variant="body1">
                    ACHIEVEMENT:&nbsp;
                    {computeAchievementKPI(
                      targets.monthly_target,
                      targets.total_sales,
                      100
                    )}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </ListItemText>
        </ListItem>
      </>
    );
  };

  const reachKPI = () => {
    return (
      <>
        <ListItem
          button
          divider
          onClick={() => {
            setOpenBreakdownDialog(true);
            setSelectedBreakdown("Reach");
          }}
          sx={{ position: "relative" }}
        >
          <ListItemText>
            <StoreIcon
              sx={{
                fontSize: "15em",
                color: "#edece6",
                position: "absolute",
                top: "50%",
                right: "1%", // Push it to the right side
                transform: "translateY(-50%)", // Center vertically
                zIndex: -2,
              }}
            />
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="h6">
                    <StoreIcon sx={{ fontSize: "large", color: "green" }} />{" "}
                    <b>{"REACH"}</b>
                  </Typography>
                  <Typography variant="body2">
                    store with sales vs target doors
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="body1">
                    TARGET: {targets.num_doors_target}
                  </Typography>
                  <Typography variant="body1">
                    ACTUAL:&nbsp;
                    {targets.total_accounts_with_sales}
                  </Typography>
                  <Typography variant="body1">
                    BALANCE:&nbsp;
                    {targets.num_doors_target -
                      targets.total_accounts_with_sales >
                    0
                      ? targets.num_doors_target -
                        targets.total_accounts_with_sales
                      : 0}
                  </Typography>
                  <Typography component="span" display="inline" variant="body1">
                    ACHIEVEMENT:&nbsp;
                    {computeAchievementKPI(
                      targets.num_doors_target,
                      targets.total_accounts_with_sales,
                      targets.reach_percentage
                    )}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </ListItemText>
        </ListItem>
      </>
    );
  };

  const rangeKPI = () => {
    return (
      <>
        <ListItem
          button
          divider
          onClick={() => {
            setOpenBreakdownDialog(true);
            setSelectedBreakdown("Range");
          }}
          sx={{ position: "relative" }}
        >
          <ListItemText>
            <EqualizerIcon
              sx={{
                fontSize: "15em",
                color: "#edece6",
                position: "absolute",
                top: "50%",
                right: "1%", // Push it to the right side
                transform: "translateY(-50%)", // Center vertically
                zIndex: -2,
              }}
            />
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="h6">
                    <EqualizerIcon sx={{ fontSize: "large", color: "green" }} />{" "}
                    <b>{"RANGE"}</b>
                  </Typography>
                  <Typography variant="body2">
                    store with {targets.num_skus_target_per_door} SKU/s vs
                    target doors
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="body1">
                    TARGET: {targets.num_doors_target}
                  </Typography>
                  <Typography variant="body1">
                    ACTUAL:&nbsp;{targets.total_accounts_with_x_skus}
                  </Typography>
                  <Typography variant="body1">
                    BALANCE:&nbsp;
                    {targets.num_doors_target -
                      targets.total_accounts_with_x_skus >
                    0
                      ? targets.num_doors_target -
                        targets.total_accounts_with_x_skus
                      : 0}
                  </Typography>
                  <Typography component="span" display="inline" variant="body1">
                    ACHIEVEMENT:&nbsp;
                    {computeAchievementKPI(
                      targets.num_doors_target,
                      targets.total_accounts_with_x_skus,
                      targets.range_percentage
                    )}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </ListItemText>
        </ListItem>
      </>
    );
  };

  const appUsageKPI = () => {
    return (
      <>
        <ListItem
          button
          divider
          // onClick={() => {
          //   setOpenBreakdownDialog(true);
          //   setSelectedBreakdown("Range");
          // }}
          sx={{ position: "relative" }}
        >
          <ListItemText>
            <MobileFriendlyIcon
              sx={{
                fontSize: "12em",
                color: "#edece6",
                position: "absolute",
                top: "50%",
                right: "1%",
                transform: "translateY(-50%)", // Center vertically
                zIndex: -2,
              }}
            />
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="h6">
                    <MobileFriendlyIcon
                      sx={{ fontSize: "large", color: "green" }}
                    />{" "}
                    <b>APP USAGE</b>
                  </Typography>
                  <Typography variant="body2">
                    seller with transactions vs target
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} lg={12}>
                <Box sx={{ marginTop: ".5em" }}>
                  <Typography variant="body1">
                    TARGET: {targets.app_usage_target}
                  </Typography>
                  <Typography variant="body1">
                    ACTUAL:&nbsp;{targets.total_app_usage}
                  </Typography>
                  <Typography variant="body1">
                    BALANCE:&nbsp;
                    {targets.app_usage_target - targets.total_app_usage > 0
                      ? targets.app_usage_target - targets.total_app_usage
                      : 0}
                  </Typography>
                  <Typography component="span" display="inline" variant="body1">
                    ACHIEVEMENT:&nbsp;
                    {computeAchievementKPI(
                      targets.app_usage_target,
                      targets.total_app_usage,
                      100
                    )}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </ListItemText>
        </ListItem>
      </>
    );
  };

  function truncateText(text, maxLength = 6) {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={classes.appBarTop}
        aria-haspopup="true"
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <div>
            <Typography variant="h6" noWrap>
              Dashboard Targets (
              {selectedSeller !== ""
                ? truncateText(
                    selectedSeller.first_name +
                      " " +
                      selectedSeller.middle_name +
                      " " +
                      selectedSeller.last_name
                  )
                : "My Targets"}
              )
            </Typography>
            <Typography variant="subtitle1">{label.filterDateLabel}</Typography>
          </div>
          <div style={{ flex: 1 }}></div>
          <IconButton
            className={classes.margin}
            onClick={menuHandleClick}
            edge="end"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            open={openMenu}
            anchorEl={menuAnchorEl}
            onClose={() => {
              setMenuAnchorEl(null);
            }}
          >
            <MenuItem
              disabled={buttonDisabled}
              onClick={() => {
                handleClickMyTargets();
                setMenuAnchorEl(null);
              }}
            >
              My Targets
            </MenuItem>
            <MenuItem
              disabled={buttonDisabled}
              onClick={() => {
                setOpenSellerMenu(true);
                setMenuAnchorEl(null);
              }}
            >
              Filter By Seller
            </MenuItem>
            <MenuItem
              disabled={buttonDisabled}
              onClick={handleFilterByDateClick}
            >
              Filter By Date
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {isLoading ? (
        <LinearProgress
          color="secondary"
          style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
        />
      ) : (
        ""
      )}
      {main()}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {SelectSellerDialog()}
          {BreakdownDialog()}
          {SelectDateRangeFilterDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
